export const EMPLOYEE_ALERT_STATUSES: {[key: string]: string} = {
  in_progress: '進行中',
  completed: '完了',
} as const
